<template>
	<div class="t-work-area__row">
		<div class="t-work-area__column_big t-schedule">
			<h2 class="_blue">{{ pageText.title_1 }}</h2>
			<div class="t-work-area__cell">
				<cmp-calendar></cmp-calendar>
			</div>

            <cmp-banner></cmp-banner>
            <cmp-promo-courses 
                :text="{title:pageText.title_4}"
                :items="recommendations.courses">
            </cmp-promo-courses>

			<template v-if="myCourses.active.items.length">
				<h2 class="_blue">{{ pageText.title_2 }}</h2>
				<div class="t-coursesList__wrap t-coursesList__wrap_margin">
					<cmp-course :data="item" v-for="(item, index) in myCourses.active.items" :key="index"></cmp-course>
				</div>
				<cmp-pagination class="_margin" v-if="myCourses.active._meta.pageCount > 1" :pages="myCourses.active._meta.pageCount" :name="'active'"></cmp-pagination>
			</template>

			<template v-if="myCourses.unpublished.items.length">
				<h2 class="_blue">{{ pageText.title_3 }}</h2>
				<div class="t-coursesList__wrap t-coursesList__wrap_margin">
					<cmp-course :data="item" v-for="(item, index) in myCourses.unpublished.items" :key="index"></cmp-course>
				</div>
				<cmp-pagination v-if="myCourses.unpublished._meta.pageCount > 1" :pages="myCourses.unpublished._meta.pageCount" :name="'unpublished'"></cmp-pagination>
			</template>

		</div>
        <cmp-promo-teachers class="t-work-area__column_small"
            :text="{title:pageText.title_5, promoBtn: pageText.promoBtn}"
            :items="recommendations.teachers">
        </cmp-promo-teachers>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/myCoursesPage.json' : 'staticText',
        main: {
            title_1: "Расписание",
            title_2: "Опубликованные",
            title_3: "Неопубликованные",
            title_4: "Рекомендуемый курс",
            title_5: "Рекомендуемый учитель",
            promoBtn: 'Заказать рекламу'
        }
    };

    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    import Course from '../../vue_components/Course.vue'
    // import Teacher from '../../vue_components/Teacher.vue'
    import Calendar from '../../vue_components/Calendar/Calendar.vue'
    import Pagination from '../../vue_components/Pagination.vue'
    import PromoTeachers from '../../vue_components/PromoTeachers.vue'
    import PromoCourses from '../../vue_components/PromoCourses.vue'

    import Banner from '../../vue_components/Banner.vue'

		export default {
        data(){
            return{
                pageText: {}
            }
        },
        components: {
            'cmp-course': Course,
            // 'cmp-teacher': Teacher,
                'cmp-calendar': Calendar,    
            'cmp-pagination': Pagination,
            'cmp-promo-teachers': PromoTeachers,
            'cmp-promo-courses': PromoCourses,
            'cmp-banner': Banner,
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('recommendations', ['recommendations']),
            ...mapGetters('coursesList', ['myCourses', 'myLessonsState']),
            ...mapGetters('calendar', ['date_active', 'calendarTypeValue', 'day_week_header']),
            ...mapGetters('standartObjects', ['swiperOption']),
            swiperOption_courses_mobile(){
                return this.swiperOption('.js-pagination_courses-2')
            },
            swiperOption_teachers_mobile(){ 
                return this.swiperOption('.js-pagination_teachers-2')
            },
        },
        watch: {
            calendarTypeValue(){
                let start, end;

                if(this.calendarTypeValue.value === 1){
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else{
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }

                this.LoadStreamsMy({start: start, end: end});
                this.LoadMyLessonsState({start: start, end: end});
            },
            date_active(){
                let start, end;

                if(this.calendarTypeValue.value === 1){
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else{
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }

                this.LoadStreamsMy({start: start, end: end});
                this.LoadMyLessonsState({start: start, end: end});
            }
        },
        methods: {
            ...mapActions('coursesList', ['LoadStreamsMy', 'LoadMyLessonsState']),
            ...mapActions(['UpdatePreloadState']),
            Load(pageText){
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 200)
            }
        },
        beforeRouteLeave (to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate (to, from, next) {
            let count = 0;

            store.dispatch('coursesList/LoadMyCourses', {page: to.query.page_active}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadMyCoursesUnpublished', {page: to.query.page_unpublished}).then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if(count > 1)
                    next()
            }
        },
        beforeRouteEnter (to, from, next) {
            let date = new Date();

            let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
            let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

            store.dispatch('calendar/LoadCalendarText').then(() => {count++;RunNext();});
            store.dispatch('coursesList/LoadMyCourses', {page: to.query.page_active}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadStreamsMy', {start: start, end: end}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadMyLessonsState', {start: start, end: end}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadMyCoursesUnpublished', {page: to.query.page_unpublished}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('recommendations/LoadRecommendations').then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if(count > 6)
                    next(vm => vm.Load(pageText))
            }
        }
		}
</script>



// WEBPACK FOOTER //
// src/vue_pages/Profile/MyCourses.vue